import React from 'react';
import { PaymentsSelectionContainer } from '../../../containers';

export const PaymentsSelection = () => <PaymentsSelectionContainer />;
